export const paths = [{ "tag": "path", "att": { "d": "M5.998 4.996h4v14.0001h-4v-14zm8 0h4v14.0001h-4v-14z" } }];
export const iconName = 'pause';
export const pause = { iconName, paths };
export default paths;
